/* eslint-disable @nx/enforce-module-boundaries */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedGatewaysModule } from '@cigna/shared/angular/gateways-util';
import { CignaForBrokersSharedUiModule } from '@cigna/cigna-for-brokers/shared/ui';
import { RouterModule } from '@angular/router';
import { HeaderLogoComponent } from './header-logo/header-logo.component';
import { HeaderSecureComponent } from './header-secure/header-secure.component';
import { HeaderUnSecureComponent } from './header-unsecure/header-unsecure.component';
import { PrimaryNavComponent } from './primary-nav/primary-nav.component';
import { NavItemSubMenuComponent } from './nav-item-sub-menu/nav-item-sub-menu.component';
import { NavItemComponent } from './nav-item/nav-item.component';
import { StatementAccessRequestDialogComponent } from './statement-access-request-dialog/statement-access-request-dialog.component';
import { UiIconModule } from '@cigna/shared/angular/icon-ui';
import { AnalyticsUiModule } from '@cigna/shared/angular/analytics-ui';
import { HeaderImpersonatorComponent } from './header-impersonator/header-impersonator.component';

@NgModule({
  imports: [
    CommonModule,
    UiIconModule,
    TranslateModule,
    SharedGatewaysModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    CignaForBrokersSharedUiModule,
    AnalyticsUiModule,
  ],
  declarations: [
    HeaderLogoComponent,
    HeaderSecureComponent,
    HeaderUnSecureComponent,
    PrimaryNavComponent,
    NavItemComponent,
    NavItemSubMenuComponent,
    StatementAccessRequestDialogComponent,
    HeaderImpersonatorComponent,
  ],
  exports: [
    HeaderLogoComponent,
    HeaderSecureComponent,
    HeaderUnSecureComponent,
    PrimaryNavComponent,
    NavItemComponent,
    StatementAccessRequestDialogComponent,
    HeaderImpersonatorComponent,
  ],
})
export class CignaForBrokersShellUiModule {}
